const state = {
  zendeskScriptLoaded: false,
}

const getters = {
  zendeskChatbotReady: (state) => {
    return state.zendeskScriptLoaded || false
  },
}

const mutations = {
  SET_ZENDESK_SCRIPT_STATUS: (state, status) => {
    state.zendeskScriptLoaded = status
  },
}

const actions = {
  setZendeskScriptLoadedStatus({ commit }, status) {
    commit('SET_ZENDESK_SCRIPT_STATUS', status)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
